import './Aeropuertos.css';
import React from "react";
import Aeropuertos0 from '../../assets/Industries/Aeropuertos/Aeropuertos0.png';
import Aeropuertos1 from '../../assets/Industries/Aeropuertos/Aeropuertos1.png';
import Aeropuertos2 from '../../assets/Industries/Aeropuertos/Aeropuertos2.png';
import Aeropuertos3 from '../../assets/Industries/Aeropuertos/Aeropuertos3.png';
import Aeropuertos4 from '../../assets/Industries/Aeropuertos/Aeropuertos4.png';
import Aeropuertos5 from '../../assets/Industries/Aeropuertos/Aeropuertos5.png';
import Aeropuertos6 from '../../assets/Industries/Aeropuertos/Aeropuertos6.png';


const images = [
    { src: Aeropuertos1, text: "Jordan Airport" },
    { src: Aeropuertos2, text: "Mauritius Airport" },
    { src: Aeropuertos3, text: "Guangzhou Baiyun Airport" },
    { src: Aeropuertos4, text: "Capital International Airport" },
    { src: Aeropuertos5, text: "Pudong Airport" },
    { src: Aeropuertos6, text: "Shenzhen Airport" },
];

function Aeropuertos() {
    return (
        <div className="arquitectura-container">
            {/* Sección con título, texto e imagen */}
            <div className="arquitectura-header">
                <div className="arquitectura-texto">
                    <h2>Aeropuertos</h2>
                    <div className="underline"></div>
                    <p>
                    El uso de más de 100 pistas de aeropuertos nos brinda razones más convincentes para brindarle una solución de sellado satisfactoria.
                    </p>
                </div>
                <div className="arquitectura-imagen">
                    <img src={Aeropuertos0} alt="Arquitectura" />
                </div>
            </div>

            {/* Sección de Imágenes en Grilla (justo debajo) */}
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <img src={item.src} alt={`Arquitectura ${index + 1}`} />
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Aeropuertos;
